import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { error } from 'react-notification-system-redux';
import { getAuthProps } from '@topconagriculture/auth';
import { useDashboardAPI } from './useDashboardContext';
import { notificationsConfig } from '../config/constants';
export const useWidgetsListQuery = (options) => {
    const dispatch = useDispatch();
    const auth = useSelector(getAuthProps);
    const api = useDashboardAPI();
    return useQuery({
        refetchOnMount: true,
        refetchOnReconnect: true,
        refetchOnWindowFocus: true,
        onError: () => dispatch(error({
            ...notificationsConfig.defaultConf,
            translationKey: 'widget:widget:cant_load_widgets',
        })),
        ...options,
        queryFn: () => api.widget.getWidgetList(auth.userId),
        queryKey: ['widgets'],
        select: (data) => (Array.isArray(data) ? data : []),
    });
};
//# sourceMappingURL=useWidgetsListQuery.js.map